import { Link } from 'react-router-dom';
import { ICluster, IDonor } from '@nkr/models/index';
import { TableWrapper, TableBodyWrapper } from './styles';

interface IProps {
    list: ICluster[],
    centerId: number
}

const LogisticsKickoffCalls = (props: IProps) => {
    const renderDonorCenter = (donor: IDonor) => {
        if (donor.rdnCenterAlias != '') {
            return <>{donor.center.alias} (<span style={{ color: 'red' }}>{donor.rdnCenterAlias}</span>)</>;
        }

        return <>{donor.center.alias}</>;
    };

    return (
        <TableWrapper className='table table-condensed table-striped'>
            <thead>
                <tr>
                    <th rowSpan={2}>Swap</th>
                    <th rowSpan={2} style={{ fontWeight: 700 }}><span style={{ color: '#63a7ff' }}>Logistics</span> / <span style={{ color: '#ff993d' }}>Kickoff</span> Calls</th>
                    <th rowSpan={2}>Swap Manager</th>
                    <th colSpan={2}>Donor</th>
                    <th colSpan={2}>Recipient</th>
                </tr>
                <tr>
                    <th>Alias</th>
                    <th>Center</th>
                    <th>Alias</th>
                    <th>Center</th>
                </tr>
            </thead>
            <TableBodyWrapper>
                {props.list.map((item, index) =>
                    <>
                        <tr key={index}>

                            <td><Link to={`/center/${props.centerId}/action-center/pending-swaps`}>{item.chainId}/{item.clusterNumber}</Link></td>
                            <td>
                                {item.logisticsDateTime && item.kickoffDateTime && (
                                    <>
                                        <span className='badge badge-info'>{item.logisticsDateTime}</span>&nbsp;/&nbsp;<span className='badge badge-warning'>{item.kickoffDateTime}</span>
                                    </>
                                )}

                                {item.logisticsDateTime && !item.kickoffDateTime && (
                                    <span className='badge badge-info'>{item.logisticsDateTime}</span>
                                )}

                                {!item.logisticsDateTime && item.kickoffDateTime && (
                                    <span className='badge badge-warning'>{item.kickoffDateTime}</span>
                                )}
                            </td>
                            <td>
                                {item.swapManager}
                                <div style={{ fontSize: 11 }}>Dial-in: {item.conferenceNumber}</div>
                            </td>

                            {item.positions.length > 0 && (
                                <>
                                    <td>{item.positions[0].donor.alias}</td>
                                    <td>{renderDonorCenter(item.positions[0].donor)}</td>
                                    <td>{item.positions[0].recipient.alias}</td>
                                    <td>{item.positions[0].recipient.center.alias}</td>
                                </>
                            )}
                        </tr>

                        {item.positions.map((position, index) => {
                            if (index > 1) {
                                return (
                                    <tr>
                                        <td colSpan={3}></td>
                                        <td>{position.donor.alias}</td>
                                        <td>{renderDonorCenter(position.donor)}</td>
                                        <td>{position.recipient.alias}</td>
                                        <td>{position.recipient.center.alias}</td>
                                    </tr>
                                );
                            }
                        })}
                    </>
                )}
            </TableBodyWrapper>
        </TableWrapper>
    );
}

export default LogisticsKickoffCalls;